
import { gql } from "@apollo/client";
import { apolloClient } from "../../services/apolloclient";

export const GET_MENUHERO = gql`
  query cafegp {
    menupage {
      heroParts {
        contentItems {
          ... on LeftSection {
            headLine
            tagLine
            cTA1 {
              text
              url
            }
            isCTA1
            isCTA2
            cTA2 {
              text
              url
            }
            enabled
          }
          ... on BackGroundSection {
            media {
              urls
            }
            enabled
            isVideo
          }
          ... on RightSection {
            title
            openDays
            openTimes
            enabled
          }
        }
      }
    }
  }
`;

export async function fetchMenuHero() {
  const result = await apolloClient.query({
    query: GET_MENUHERO,
    fetchPolicy: "network-only",
  });

  return result.data;
}
